/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import _ from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import custom component
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SearchTypeComponent from '../../../../SharedModules/SearchTypeComponent/SearchTypeComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { TableHeaderForManufacturer } from './gridComponents/tableHead';
// import custom function
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  radioGroupLabelNamePlan,
  radioGroupLabelNameSelectBy,
  rebateProgramLabelName,
  viewPortHeight_355,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import { CMS_ROSI_MANUFACTURE, DOUBLE_CLICK } from './ConstData';
import {
  tabHighLigther,
  isReadOnly as isRead,
} from '../../../../SharedModules/utilities/utilities';
import {
  redirectURLLink,
  upperCaseFirstLetter,
  lowerCaseAllWordsExceptFirstLetters,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  getCommonDropdownList,
  handleErrorMessages,
  getCheckBoxValue,
  getCmsRosiByCriteria,
  getAuditTypeDropDownList,
  getManufacturerList,
  setSearchCmsRosiTab,
  handleSuccessMessages,
} from '../store/Actions';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';

const CmsRosiSearch = ({ location }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  /* dispatch function */
  const setSearchCmsRosi = (value) => dispatch(setSearchCmsRosiTab(value));
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  let isReadOnly;
  if (loginState) {
    isReadOnly = isRead(location.pathname, loginState).readOnly;
  }
  // use Selector function
  const getRebateProgramList = useSelector(
    (state) => state.sharedState.CMSRosiReducer.dropdown
  );
  const searchCmsRosiTabData = useSelector(
    (state) => state.sharedState.CMSRosiReducer.searchCmsRosiObj
  );
  const getPlanTypeData = useSelector(
    (state) => state.sharedState.CMSRosiReducer.checkbox
  );
  const fetchManufacturerList = useSelector(
    (state) => state.sharedState.CMSRosiReducer.manufacturerList
  );
  const auditTypeOptions = useSelector(
    (state) => state.sharedState.CMSRosiReducer.auditTypeList
  );
  const errorMessagesFromRedux = useSelector(
    (state) => state?.sharedState?.CMSRosiReducer?.errorMessagesInRedux
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  // variable deceleration
  const searchCompObj = searchCmsRosiTabData?.state?.searchTypeState;
  const errorMessagesOfSearchTypeComp =
    errorMessagesFromRedux?.searchScreenErrors?.length > 0
      ? _.filter(
          errorMessagesFromRedux?.searchScreenErrors,
          (l) => l?.errorComponent === 'searchTypeComponent' && l.message
        ).map((val) => val)
      : [];
  const gridRef = React.useRef();

  // states with initial values
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [commonDropDownList, setCommonDropDownList] = React.useState([]);
  const [manufacturerList, setManufacturerList] = React.useState([]);
  const [selectManufacturer, setSelectManufacturer] = React.useState({});
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [confirmAction, setConfirmAction] = React.useState(false);
  const [payload, setPayload] = React.useState();
  const [labelerFullScreen, setLabelerFullScreen] = React.useState(
    searchCompObj?.labelerFullScreenRedux
      ? searchCompObj?.labelerFullScreenRedux
      : false
  );
  const [ndcLeftFullScreen, setNdcLeftFullScreen] = React.useState(
    searchCompObj?.ndcLeftFullScreenRedux
      ? searchCompObj?.ndcLeftFullScreenRedux
      : false
  );
  const [ndcRightFullScreen, setNdcRightFullScreen] = React.useState(
    searchCompObj ? searchCompObj.ndcRightFullScreenRedux : false
  );
  const [labelerSelectedRow, setlabelerSelectedRow] = React.useState(
    searchCompObj?.labelerSelectedRowRedux
      ? searchCompObj?.labelerSelectedRowRedux
      : ''
  );
  const [ndcLeftSelectedRows, setNdcLeftSelectedRows] = React.useState(
    searchCompObj?.ndcLeftSelectedRowsRedux
      ? searchCompObj?.ndcLeftSelectedRowsRedux
      : []
  );
  const [ndcRightSelectedRows, setNdcRightSelectedRows] = React.useState(
    searchCompObj?.ndcRightSelectedRowsRedux
      ? searchCompObj?.ndcRightSelectedRowsRedux
      : []
  );
  const [labelerTableData, setlabelerTableData] = React.useState(
    searchCompObj?.labelerTableDataRedux
      ? searchCompObj?.labelerTableDataRedux
      : []
  );
  const [ndcLeftTableData, setNdcLeftTableData] = React.useState(
    searchCompObj?.ndcLeftTableDataRedux
      ? searchCompObj?.ndcLeftTableDataRedux
      : []
  );
  const [ndcRightTableData, setNdcRightTableData] = React.useState(
    searchCompObj?.ndcRightTableDataRedux
      ? searchCompObj?.ndcRightTableDataRedux
      : []
  );
  const [ndcSearchVal, setNdcSearchVal] = React.useState(
    searchCompObj?.ndcSearchTextRedux ? searchCompObj?.ndcSearchTextRedux : ''
  );
  const [ndcNameSearchVal, setNdcNameSearchVal] = React.useState(
    searchCompObj?.ndcNameSearchTextRedux
      ? searchCompObj?.ndcNameSearchTextRedux
      : ''
  );
  // eslint-disable-next-line no-nested-ternary
  const [searchType, setSearchType] = React.useState(
    searchCompObj?.valueSelectedRedux
      ? searchCompObj?.valueSelectedRedux
      : userDefaults?.defNdcSelectModeCd
      ? userDefaults?.defNdcSelectModeCd === 'NDC'
        ? 'NDC'
        : upperCaseFirstLetter(
            lowerCaseAllWordsExceptFirstLetters(
              userDefaults?.defNdcSelectModeCd
            )
          )
      : 'N'
  );
  const [errorMsgFromSearchType, setErrorMsgFromSearchType] = React.useState(
    errorMessagesOfSearchTypeComp
  );
  const [state, setState] = React.useState(
    searchCmsRosiTabData?.state
      ? searchCmsRosiTabData.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? userDefaults?.rebateProgramCd
            : '-1',
          selectBy: 'A',
          auditTypeCd: 'ALL',
          quarterValue: null,
          selectedAuditType: '-1',
          clearedIndex: false,
          unclearedIndex: true,
          allAuditTypes: true,
          drugSeqNo: [],
          searchTypeState: {
            valueSelectedRedux: 'N',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        }
  );

    React.useEffect(() => {
      if (Object.keys(state || {}).length > 0) {
        dispatch(handleErrorMessages({ searchScreenErrors: [] }));
      }
    }, [state]);
  // handle all plan type get service
  React.useEffect(() => {
    if (!getPlanTypeData?.PLAN_TYPE_CD) {
      dispatch(getCheckBoxValue());
    }
  }, []);
  // handing refresh functionality
  React.useEffect(() => {
    const searchObj = {
      valueSelectedRedux: searchType || 'N',
      ndcSearchTextRedux: ndcSearchVal || '',
      ndcNameSearchTextRedux: ndcNameSearchVal || '',
      ndcLeftTableDataRedux: ndcLeftTableData || [],
      ndcRightTableDataRedux: ndcRightTableData || [],
      labelerTableDataRedux: labelerTableData || [],
      ndcLeftSelectedRowsRedux: ndcLeftSelectedRows || [],
      ndcRightSelectedRowsRedux: ndcRightSelectedRows || [],
      labelerSelectedRowRedux: labelerSelectedRow || '',
      labelerFullScreenRedux: labelerFullScreen,
      ndcLeftFullScreenRedux: ndcLeftFullScreen,
      ndcRightFullScreenRedux: ndcRightFullScreen,
    };
    setState({ ...state, searchTypeState: searchObj });
    setSearchCmsRosi({
      fullScreenView: fullScreenView,
      state: { ...state, searchTypeState: searchObj },
    });
  }, [
    searchType,
    labelerSelectedRow,
    ndcLeftSelectedRows,
    ndcRightSelectedRows,
    labelerTableData,
    ndcLeftTableData,
    ndcRightTableData,
    ndcSearchVal,
    ndcNameSearchVal,
    labelerFullScreen,
    ndcLeftFullScreen,
    ndcRightFullScreen,
  ]);
  // handing full screen view
  React.useEffect(() => {
    if (labelerFullScreen || ndcLeftFullScreen || ndcRightFullScreen) {
      setFullScreenView(true);
      const searchObj = {
        valueSelectedRedux: searchType || 'N',
        ndcSearchTextRedux: ndcSearchVal || '',
        ndcNameSearchTextRedux: ndcNameSearchVal || '',
        ndcLeftTableDataRedux: ndcLeftTableData || [],
        ndcRightTableDataRedux: ndcRightTableData || [],
        labelerTableDataRedux: labelerTableData || [],
        ndcLeftSelectedRowsRedux: ndcLeftSelectedRows || [],
        ndcRightSelectedRowsRedux: ndcRightSelectedRows || [],
        labelerSelectedRowRedux: labelerSelectedRow || '',
        labelerFullScreenRedux: labelerFullScreen,
        ndcLeftFullScreenRedux: ndcLeftFullScreen,
        ndcRightFullScreenRedux: ndcRightFullScreen,
      };
      setSearchCmsRosi({
        fullScreenView: true,
        state: { ...state, searchTypeState: searchObj },
      });
    } else {
      setFullScreenView(false);
      setSearchCmsRosi({
        fullScreenView: false,
        state: state,
      });
    }
  }, [labelerFullScreen, ndcLeftFullScreen, ndcRightFullScreen]);

  // handling onPage load call service
  React.useEffect(() => {
    if (state.selectBy === 'M') {
      dispatch(handleErrorMessages({ searchScreenErrors: [] }));
      dispatch(getManufacturerList({ mfgId: null, showAllInd: true }));
    }
    handleScrollToEvent();
  }, []);

  // Audit code dropdown
  React.useEffect(() => {
    if (
      searchCmsRosiTabData &&
      Object.keys(searchCmsRosiTabData).length === 0
    ) {
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
      dispatch(
        getAuditTypeDropDownList({ domainKey: 'AUDIT_TYPE_CD', codeValue: 'R' })
      );
    } else if (searchCmsRosiTabData?.fullScreenView) {
      setFullScreenView(searchCmsRosiTabData.fullScreenView);
    }
  }, []);
  // set common dropdown list
  React.useEffect(() => {
    let dropdownData = dispatch(getCommonDropdownList(state.planTypeCd));
    dropdownData.then((response) => {
      setCommonDropDownList(response);
    });
  }, [state.planTypeCd]);
  // set Manufacturer list
  React.useEffect(() => {
    setManufacturerList(fetchManufacturerList);
  }, [fetchManufacturerList]);
  // set Rebate Program List
  React.useEffect(() => {
    let list = [];
    if (
      commonDropDownList?.status === constantMessageData.STATUS_MSG &&
      commonDropDownList?.message === constantMessageData.SUCCESS_MSG
    ) {
      if (!_.isEmpty(commonDropDownList.data)) {
        list = _.map(commonDropDownList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  }, [commonDropDownList]);

  // handing highlight tab
  React.useEffect(() => {
    if (
      errorMessagesFromRedux?.searchScreenErrors &&
      errorMessagesFromRedux?.searchScreenErrors.length > 0
    ) {
      tabHighLigther('/cmsRosi', true);
    } else {
      tabHighLigther('/cmsRosi', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };
  // click on filter icon after call
  const handleClearFilter = () => {
    if (manufacturerList && manufacturerList.length > 0 && gridRef?.current) {
      gridRef.current.clearFilters();
    }
  };
  // Calling API for Manufacturer List
  const getManufactureListData = (name, value) => {
    dispatch(
      getManufacturerList(
        // eslint-disable-next-line no-nested-ternary
        {
          showAllInd: true,
          mfgId: null,
        }
      )
    );
    handleClearFilter();
  };
  // handing On change event on filed level
  const handleOnChangeEvent = (value, name) => {
    if (name === 'selectBy' && value !== state.selectBy) {
      setState({
        ...state,
        searchTypeState: {
          valueSelectedRedux: 'N',
          ndcSearchTextRedux: '',
          ndcNameSearchTextRedux: '',
          ndcLeftTableDataRedux: [],
          ndcRightTableDataRedux: [],
          labelerTableDataRedux: [],
          ndcLeftSelectedRowsRedux: [],
          ndcRightSelectedRowsRedux: [],
          labelerSelectedRowRedux: '',
          ndcLeftFullScreenRedux: false,
          ndcRightFullScreenRedux: false,
          labelerFullScreenRedux: false,
        },
      });
      setSearchType(
        userDefaults?.defNdcSelectModeCd
          ? userDefaults?.defNdcSelectModeCd === 'NDC'
            ? 'NDC'
            : upperCaseFirstLetter(
                lowerCaseAllWordsExceptFirstLetters(
                  userDefaults?.defNdcSelectModeCd
                )
              )
          : 'N'
      );
      setNdcLeftSelectedRows([]);
      setlabelerSelectedRow('');
      setNdcRightSelectedRows([]);
      setlabelerTableData([]);
      setNdcLeftTableData([]);
      setNdcRightTableData([]);
      setNdcSearchVal('');
      setNdcNameSearchVal('');
      setSearchCmsRosi({
        fullScreenView: fullScreenView,
        state: {
          ...state,
          searchTypeState: {
            valueSelectedRedux: 'N',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        },
      });
      let errorMsgWithoutSearch = errorMessagesFromRedux?.searchScreenErrors
        ? errorMessagesFromRedux?.searchScreenErrors
        : [];
      errorMsgWithoutSearch = errorMsgWithoutSearch.filter(
        (item) =>
          item?.errorComponent !== 'searchTypeComponent' &&
          item.message !== constantMessageData.MNFC_NDC_ERROR_MSG
      );
      setErrorMsgFromSearchType([]);
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(errorMsgWithoutSearch)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
    }
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setSearchCmsRosi({
        fullScreenView: fullScreenView,
        state: { ...state, [name]: value, rebateProgramCd: '-1' },
      });
    } else if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setSearchCmsRosi({
        fullScreenView: fullScreenView,
        state: { ...state, [name]: value },
      });
    } else if (name === 'allAuditTypes') {
      setState({ ...state, [name]: value });
      setSearchCmsRosi({
        fullScreenView: fullScreenView,
        state: { ...state, [name]: value, selectedAuditType: '-1' },
      });
    } else if (name === 'unclearedIndex') {
      setState({
        ...state,
        [name]: value,
        clearedIndex: (state.clearedIndex = true),
      });
      setSearchCmsRosi({
        fullScreenView: fullScreenView,
        state: { ...state, [name]: value, selectedAuditType: '-1' },
      });
    } else if (name === 'clearedIndex') {
      setState({
        ...state,
        [name]: value,
        unclearedIndex: (state.unclearedIndex = true),
      });
      setSearchCmsRosi({
        fullScreenView: fullScreenView,
        state: { ...state, [name]: value, selectedAuditType: '-1' },
      });
    } else {
      setState({ ...state, [name]: value });
      setSearchCmsRosi({
        fullScreenView: fullScreenView,
        state: { ...state, [name]: value },
      });
    }
    if (name === 'selectBy' && value === 'M') {
      getManufactureListData();
    }
  };
  // hading On blur event on filed level
  const handleOnblurEvent = (type, value) => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors
      ? errorMessagesFromRedux?.searchScreenErrors
      : [];
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' &&
            item.field !== 'resultNotFound' &&
            item.field !== 'NoSelectedRow'
        );
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' &&
            item.field !== 'resultNotFound' &&
            item.field !== 'NoSelectedRow'
        );
        if (state.selectBy === 'M') {
          getManufactureListData(
            'rebateProgramCd',
            value === '-1' ? null : value
          );
        }
      }
    }
    dispatch(
      handleErrorMessages({
        searchScreenErrors: [...new Set(localErr)],
        detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
          ? errorMessagesFromRedux?.detailScreenErrors
          : [],
      })
    );
  };
  // set Error messages
  const getErrorsFromSearchTypeComponent = (errors) => {
    let alreadyPresentErrors = errorMessagesFromRedux?.searchScreenErrors
      ? errorMessagesFromRedux?.searchScreenErrors
      : [];
    if (errors) {
      setErrorMsgFromSearchType(errors);
      alreadyPresentErrors = alreadyPresentErrors.filter(
        (item) =>
          item?.errorComponent !== 'searchTypeComponent' &&
          item.message !== constantMessageData.MNFC_NDC_ERROR_MSG
      );
      alreadyPresentErrors = alreadyPresentErrors.concat(errors);
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(alreadyPresentErrors)],
        })
      );
    }
  };
  // handing full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setSearchCmsRosi({
      fullScreenView: !fullScreenView,
      state: state,
    });
  };
  // redirect view detail page
  const handleViewButton = () => {
    redirectURLLink(
      '/cmsRosiDetails',
      'CMS ROSI Detail',
      history,
      dispatch,
      isReadOnly
    );
  };

  const ndc1000Limit = async () => {
    setConfirmAction(false);
    const resultData = await dispatch(
      getCmsRosiByCriteria({
        ...payload,
        drugSeqNums: payload?.drugSeqNums?.filter((obj, ind) => ind < 1000),
      })
    );
    if (resultData?.searchInvoiceByCriteriaList?.cmsRosiResponse?.length > 0) {
      handleViewButton();
      dispatch(handleSuccessMessages([]));
    } else {
      const localErr = errorMessagesFromRedux?.searchScreenErrors || [];
      localErr.push({
        message: constantMessageData.MNFC_NDC_ERROR_MSG,
      });
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(localErr)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
      handleScrollToEvent();
    }
  };

  // Search
  const handleViewDetailFunction = async (data) => {
    dispatch(handleErrorMessages({ searchScreenErrors: [] }));
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    if (state.rebateProgramCd === '-1') {
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'required',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED,
      });
    }
    if (
      (state.selectBy === 'M' && data.mfgId === undefined) ||
      data.mfgId === null
    ) {
      let exist = localErr.filter((e) => e.field == 'manufacture');
      if (exist?.length == 0) {
        localErr.push({
          field: 'manufacture',
          message: constantMessageData.NOT_SELECTED_ROW,
        });
      }
    } else {
      localErr = localErr.filter((e) => e.field !== 'manufacture');
    }
    if (localErr?.length > 0) {
      handleScrollToEvent();
    }
    dispatch(
      handleErrorMessages({ searchScreenErrors: [...new Set(localErr)] })
    );
    if (state.rebateProgramCd !== null && state.rebateProgramCd !== '-1') {
      const clearedObj = {
        rebateProgramCode: state.rebateProgramCd,
        clearedIndex: state.clearedIndex ? 1 : null,
        unclearedIndex: state.unclearedIndex ? null : 1,
        selectionType: state.selectBy === 'NDC' ? 'N' : state.selectBy,
        drugSeqNums: state.drugSeqNo,
      };
      const unClearedObj = {
        rebateProgramCode: state.rebateProgramCd,
        clearedIndex: state.clearedIndex ? null : 0,
        unclearedIndex: state.unclearedIndex ? 0 : null,
        selectionType: state.selectBy === 'NDC' ? 'N' : state.selectBy,
        drugSeqNums: state.drugSeqNo,
      };
      const allObj = {
        rebateProgramCode: state.rebateProgramCd,
        clearedIndex: state.clearedIndex ? 1 : null,
        unclearedIndex: state.unclearedIndex ? 0 : null,
        selectionType: state.selectBy === 'NDC' ? 'N' : state.selectBy,
        drugSeqNums: state.drugSeqNo,
      };
      const finalObj =
        state.clearedIndex && state.unclearedIndex
          ? allObj
          : state.clearedIndex
          ? clearedObj
          : unClearedObj;
      const searchPlayload = state.allAuditTypes
        ? { ...finalObj }
        : { ...finalObj, auditTypeCd: state.selectedAuditType };

      const drugSeqArr = [];

      if (state.selectBy === 'NDC') {
        data.forEach((elem) => {
          drugSeqArr.push(elem.drugSeqNum);
        });
      }
      const searchErrors = localErr?.filter(
        (item) => item.errorComponent === 'searchTypeComponent'
      );
      setErrorMsgFromSearchType(searchErrors);
      if (localErr && !localErr.length > 0) {
        tabHighLigther('/cmsRosi', false);
      }
       localErr =  [];
      if (localErr && localErr.length === 0) {
        if (state.selectBy === 'NDC' && drugSeqArr.length > 1000) {
          setPayload({
            ...searchPlayload,
            drugSeqNums: drugSeqArr,
          });
          setConfirmAction(true);
          return;
        }
        const resultData = await dispatch(
          state.selectBy === 'M'
            ? getCmsRosiByCriteria({
                ...searchPlayload,
                mfgId: selectManufacturer.mfgId,
              })
            : state.selectBy === 'NDC'
            ? getCmsRosiByCriteria({
                ...searchPlayload,
                drugSeqNums: drugSeqArr,
              })
            : getCmsRosiByCriteria({
                ...searchPlayload,
                mfgId: data.mfgId,
                drugSeqNums: drugSeqArr,
              })
        );
        if (
          resultData?.searchInvoiceByCriteriaList?.cmsRosiResponse?.length > 0
        ) {
          handleViewButton();
          dispatch(handleSuccessMessages([]));
        } else {
          const localErr = errorMessagesFromRedux?.searchScreenErrors || [];
          localErr.push({
            message: constantMessageData.MNFC_NDC_ERROR_MSG,
          });
          dispatch(
            handleErrorMessages({
              searchScreenErrors: [...new Set(localErr)],
              detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
                ? errorMessagesFromRedux?.detailScreenErrors
                : [],
            })
          );
          handleScrollToEvent();
        }
      }
    }
  };
  const [gridApi, setGridApi] = React.useState(null);
    const onGridReady = (params) => {
      setGridApi(params.api);
    };
    React.useEffect(() => {
      if (!gridApi || manufacturerList === 0) return;
      const selectedRows = gridApi.getSelectedRows();
      if (selectedRows?.length > 0) return;
      const firstNode = gridApi.getDisplayedRowAtIndex(0);
      if (firstNode) {
        firstNode.setSelected(true);
      }
    }, [gridApi, manufacturerList]);
  return (
    <div
      className="tBillPanel custom-check tabs-container frr-cms-rosi"
      data-testid="cms-rosi-search"
    >
      <CustomSeparator parent1="Research" parent2="CMS ROSI" />
      {!fullScreenView && (
        <>
          <DisplayErrorMessages
            errorMessages={[
              ...new Set(
                errorMessagesFromRedux?.searchScreenErrors?.length > 0
                  ? _.map(
                      errorMessagesFromRedux.searchScreenErrors,
                      (l) => l.message
                    )
                  : []
              ),
            ]}
          />
          <Spinner load={spinnerLoader} />
        </>
      )}
      {!fullScreenView && (
        <div className="row">
          <div className="col-6 col-lg-7">
            <div className="row">
              <div className="col-6 col-sm-12 col-xl-7">
                <RadioGroupComponent
                  data-testid="filter-plan-by-radio-btn-plan"
                  id="filter-plan-by-radio-btn-action"
                  labelName={radioGroupLabelNamePlan}
                  required={false}
                  optionList={[
                    { name: 'Medicaid', value: 'FD' },
                    { name: 'Supplemental', value: 'SUPP' },
                    { name: 'State', value: 'ST' },
                  ]}
                  defaultValue={state && state.planTypeCd}
                  filterAction={(e) => {
                    if (e !== 'M') {
                      setSelectManufacturer({});
                    }
                    handleOnChangeEvent(e, 'planTypeCd');
                  }}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                />
              </div>
              <div className="col-6 col-sm-12 col-xl-5">
                <div className="mui-custom-form with-select">
                  <TextField
                    data-testid="rebate_program-ia"
                    id="rebate_program"
                    label={rebateProgramLabelName}
                    fullWidth
                    select
                    required
                    placeholder=""
                    inputProps={{ maxLength: 11, id: 'rebate_program' }}
                    onBlur={(e) =>
                      handleOnblurEvent('rebateProgramCd', e.target.value)
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={state && state.rebateProgramCd}
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                    }
                    className={
                      errorMessagesFromRedux?.searchScreenErrors?.length > 0
                        ? _.map(
                            errorMessagesFromRedux.searchScreenErrors,
                            (l) =>
                              l.field === 'rebateProgramCd'
                                ? 'mandate-fields'
                                : null
                          )
                        : null
                    }
                    error={
                      errorMessagesFromRedux?.searchScreenErrors?.length > 0
                        ? _.map(
                            errorMessagesFromRedux.searchScreenErrors,
                            (l) =>
                              l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                    helperText={
                      errorMessagesFromRedux?.searchScreenErrors?.length > 0
                        ? _.map(
                            errorMessagesFromRedux.searchScreenErrors,
                            (l) =>
                              l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                  >
                    <MenuItem selected key="" value="">
                      {' '}
                    </MenuItem>
                    {rebateProgramList &&
                    rebateProgramList.length &&
                    rebateProgramList.length > 0
                      ? rebateProgramList.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
              </div>
              <div className="col-12 col-lg-12 mt-3">
                <RadioGroupComponent
                  data-testid="filter-plan-by-radio-btn-select-by"
                  id="filter-plan-by-radio-btn-action"
                  labelName={radioGroupLabelNameSelectBy}
                  required={false}
                  optionList={[
                    { name: 'Manufacturer', value: 'M' },
                    { name: 'NDC', value: 'NDC' },
                    { name: 'Select All For Above Criteria', value: 'A' },
                  ]}
                  defaultValue={state && state.selectBy}
                  filterAction={(e) => {
                    if (e !== 'M') {
                      setSelectManufacturer({});
                    }
                    handleOnChangeEvent(e, 'selectBy');
                  }}
                  className=""
                />
              </div>
            </div>
          </div>
          <div className="col-6 col-lg-5">
            <div className="d-flex flex-column justify-content-sm-start  justify-content-xl-around h-100">
              <div className="no-lbl mt-2 d-flex flex-row flex-sm-column flex-xl-row">
                <FormControlLabel
                  className="ml-0"
                  data-testid="checked_ia"
                  control={<Checkbox color="primary" className="mr-2" />}
                  label="All&nbsp;Audit&nbsp;Types"
                  value={state.allAuditTypes}
                  checked={state.allAuditTypes}
                  onChange={(e) =>
                    handleOnChangeEvent(e.target.checked, 'allAuditTypes')
                  }
                />
                <div className="form-wrapper db frr-width-60">
                  <div className="with-select">
                    <TextField
                      data-testid="selec_audit_type_ia"
                      id="selectedAuditType"
                      label="Audit Type"
                      name="selectedAuditType"
                      className="frr-display-hidden-label"
                      fullWidth
                      select
                      disabled={state.allAuditTypes}
                      placeholder=""
                      inputProps={{ maxLength: 11, id: 'selectedAuditType' }}
                      InputLabelProps={{ shrink: true }}
                      value={
                        state.allAuditTypes ? '-1' : state.selectedAuditType
                      }
                      onChange={(e) => {
                        handleOnChangeEvent(
                          e.target.value,
                          'selectedAuditType'
                        );
                      }}
                    >
                      <MenuItem selected key="" value="">
                        {/* eslint-disable-next-line jsx-a11y/label-has-for */}
                        {''}
                      </MenuItem>
                      {auditTypeOptions && auditTypeOptions.length > 0
                        ? auditTypeOptions.map((item) => {
                            return (
                              <MenuItem
                                key={item.codeValue}
                                value={item.codeValue}
                              >
                                {`${item.codeValue} | ${item.shortDescription}`}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </div>
              </div>
              <div className="with-select">
                <FormControlLabel
                  className="ml-0"
                  data-testid="checked_iac"
                  control={<Checkbox color="primary" className="mr-2" />}
                  label="Include Cleared Audits"
                  value={state.clearedIndex}
                  checked={state.clearedIndex}
                  onChange={(e) =>
                    handleOnChangeEvent(e.target.checked, 'clearedIndex')
                  }
                />
              </div>
              <div>
                <FormControlLabel
                  className="ml-0"
                  data-testid="checked_iau"
                  control={<Checkbox color="primary" className="mr-2" />}
                  label="Include Uncleared Audits"
                  value={state.unclearedIndex}
                  checked={state.unclearedIndex}
                  onChange={(e) =>
                    handleOnChangeEvent(e.target.checked, 'unclearedIndex')
                  }
                />
              </div>
            </div>
          </div>
          {(state && state.selectBy === 'A') ||
          (state && state.selectBy === 'M') ? (
            <div className="col-12 mt-3">
              <div className="input-md frr-checkinvoice-search text-right">
                <Button
                  className="btn btn-success btn-save"
                  data-testid="process-button"
                  onClick={() => handleViewDetailFunction(selectManufacturer)}
                >
                  <SVGComponent iconName="Icon-view" />
                  &nbsp;View Discrepancies
                </Button>
              </div>
            </div>
          ) : null}
        </div>
      )}
      <div>
        {state && state.selectBy === 'M' ? (
          <TableGrid
            ref={gridRef}
            data-testid="manufacturer-ia-table"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            gridCall={onGridReady}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            rowData={manufacturerList}
            columnDefs={TableHeaderForManufacturer}
            onSelect={(e) => {
              dispatch(
                handleErrorMessages({
                  searchScreenErrors: [],
                  detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
                    ? errorMessagesFromRedux?.detailScreenErrors
                    : [],
                })
              );
              setSelectManufacturer(e.data);
            }}
            cellClickedListener={(e) => {
              handleViewDetailFunction(e.data);
              setSearchCmsRosi({
                state: state,
                fullScreenView: fullScreenView,
                selectRowIndex: e.rowIndex,
              });
            }}
            exportFile
            animateRows
            sideBar={false}
            helpMessage={DOUBLE_CLICK}
            fileName={CMS_ROSI_MANUFACTURE}
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
          />
        ) : state && state.selectBy === 'NDC' ? (
          <div className="mt-3">
            <SearchTypeComponent
              id="Cms-Rosi"
              data-testid="search-type-ia"
              viewDetailButtonName="View Discrepancies"
              searchType={searchType}
              setSearchType={setSearchType}
              getErrorsFromSearchTypeComponent={
                getErrorsFromSearchTypeComponent
              }
              errorMsgFromSearchType={errorMsgFromSearchType}
              setLabelerFullScreen={setLabelerFullScreen}
              labelerFullScreen={labelerFullScreen}
              setNdcLeftFullScreen={setNdcLeftFullScreen}
              ndcLeftFullScreen={ndcLeftFullScreen}
              setNdcRightFullScreen={setNdcRightFullScreen}
              ndcRightFullScreen={ndcRightFullScreen}
              handleViewDetailFunction={handleViewDetailFunction}
              setlabelerSelectedRow={setlabelerSelectedRow}
              labelerSelectedRow={labelerSelectedRow}
              setNdcLeftSelectedRows={setNdcLeftSelectedRows}
              ndcLeftSelectedRows={ndcLeftSelectedRows}
              setNdcRightSelectedRows={setNdcRightSelectedRows}
              ndcRightSelectedRows={ndcRightSelectedRows}
              setlabelerTableData={setlabelerTableData}
              labelerTableData={labelerTableData}
              setNdcLeftTableData={setNdcLeftTableData}
              ndcLeftTableData={ndcLeftTableData}
              setNdcRightTableData={setNdcRightTableData}
              ndcRightTableData={ndcRightTableData}
              setNdcSearchVal={setNdcSearchVal}
              ndcSearchVal={ndcSearchVal}
              setNdcNameSearchVal={setNdcNameSearchVal}
              ndcNameSearchVal={ndcNameSearchVal}
            />
          </div>
        ) : null}
      </div>
      <CommonModal
        open={confirmAction}
        viewAction
        className="dialog-420"
        viewHeader
        onOk={() => {
          setConfirmAction(false);
          ndc1000Limit();
        }}
        okTitle="Ok"
        closeTitle="Cancel"
        onClose={() => setConfirmAction(false)}
        modalTitle="Confirmation Dialog"
        childrenComponent={constantMessageData.NDC_LIMIT_TO_1000}
      />
    </div>
  );
};
export default CmsRosiSearch;
